(function () {
  'use strict';

  /*
   * Okendo's script hydrates every [data-oke-star-rating] element once, during
   * its initial pass. Sections that arrive after that pass -- the PDP
   * recommendations slider, complementary products, filtered or paginated
   * collection grids -- carry star-rating placeholders that never get filled
   * and render as empty gaps.
   *
   * Watch for placeholders appearing after load and ask Okendo to run again.
   */

  var SELECTOR = '[data-oke-star-rating]';
  var DEBOUNCE_MS = 250;
  var pending = null;

  function hasUnhydratedRatings() {
    var ratings = document.querySelectorAll(SELECTOR);
    for (var i = 0; i < ratings.length; i++) {
      if (ratings[i].children.length === 0) return true;
    }
    return false;
  }

  function refresh() {
    pending = null;
    if (!window.okeWidgetApi || !hasUnhydratedRatings()) return;
    window.okeWidgetApi.initAllWidgets();
  }

  function schedule() {
    if (pending) return;
    pending = setTimeout(refresh, DEBOUNCE_MS);
  }

  function containsRating(node) {
    if (node.nodeType !== 1) return false;
    return node.matches(SELECTOR) || node.querySelector(SELECTOR) !== null;
  }

  var observer = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var added = mutations[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        if (containsRating(added[j])) {
          schedule();
          return;
        }
      }
    }
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });

  // Okendo's script is loaded by the app embed and may land after this file.
  document.addEventListener('DOMContentLoaded', schedule);
})();
